<template>
  <div class="row">
    <div class="col-md-8" style="font-size: 11px">
      Nombre del archivo<br /><label>Segmento_de_clientes.txt</label>
    </div>
    <div class="col-md-1"></div>
    <div class="col-md-3">
      &nbsp;&nbsp;<label class="text-reader" style="font-size: 10px">
        <i class="fas fa-upload"></i>
        <input
          ref="examplefile"
          type="file"
          @change="loadTextFromFile"
          style="display: none"
          accept=".txt"
        />
      </label>
    </div>
    <hr style="height: 1px" />
    <div class="col-md-9" style="height: 3px">
      <label style="font-size: 11px"> {{ fileNameFile }}</label>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileNameFile: "",
      textoCodigos: "",
    };
  },
  methods: {
    loadTextFromFile(ev) {
      console.log(ev);
      const file = ev.target.files[0];
      const { name: fileName, size } = file;
      this.fileNameFile = `${fileName}`;
      if (this.fileNameFile === "Segmento_de_clientes.txt") {
        const reader = new FileReader();
        reader.onload = (e) => this.$emit("load", e.target.result);
        reader.readAsText(file);
        //console.log(reader.readAsText(file));
        // Convert size in bytes to kilo bytes
        const fileSize = (size / 1000).toFixed(2);
        // Set the text content
        const fileNameAndSize = `${fileName} - ${fileSize}KB`;
        console.log(fileNameAndSize);
      } else {
        this.$swal({
          position: "top-end",
          icon: "warning",
          title: "Archivo no corresponde!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.abortar();
        return;
      }
      this.abortar();
    },
    abortar() {
      console.log("borrado");
      this.$refs.examplefile.value = null;
    },
  },
};
</script>

<style>
.text-reader {
  position: relative;
  overflow: hidden;
  display: inline-block;

  /* Fancy button looking */
  border: 2px solid black;
  border-radius: 5px;
  padding: 8px 12px;
  cursor: pointer;
}
.text-reader input {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
}
</style>
